import { Injectable } from '@angular/core';

import { MinhasPermissoes, TokenAutorizacao } from 'src/app/models/User/MinhaAcaoPermissao.model';
import { ApiErrorResponse, ApiService, ApiSuccessResponse } from '../api/api.service';

// Rotas v1/permissao e v1/autorizacao da API
@Injectable({
    providedIn: 'root'
})
export class AutorizacaoService {
    constructor(private api: ApiService) { }

    // Ação do usuário logado em cada funcionalidade do WEB
    public async getMinhasPermissoes(): Promise<MinhasPermissoes> {
        const r = await this.api.get<MinhasPermissoes>('/v1/permissao/minhas');
        if (r?.success && r.data?.permissoes) return r.data;

        throw new Error(r?.message || 'Erro ao carregar as permissões do usuário');
    }

    // A conta tem mais de um usuário ativo? (define se o modal pede só a senha ou a escolha administrador / usuário)
    public async getTemVariosUsuarios(): Promise<boolean> {
        const r = await this.api.get<{ hasMultipleUsers: boolean }>('/v1/autorizacao/opcoes');
        if (r?.success && typeof r.data?.hasMultipleUsers === 'boolean') return r.data.hasMultipleUsers;

        throw new Error(r?.message || 'Erro ao carregar as opções de autorização');
    }

    // Valida o autorizado e devolve o token de autorização da funcionalidade
    public async validar(funcionalidadeSistemaId: number, credenciais: { password: string; user?: string; asAdministrator?: boolean }):
        Promise<ApiSuccessResponse<TokenAutorizacao> | ApiErrorResponse> {
        return this.api.post<TokenAutorizacao>('/v1/autorizacao/validar', { funcionalidadeSistemaId, ...credenciais });
    }
}
